export class SortOption {
  key: string;

  label: string;

  constructor(key: string, label: string) {
    this.key = key;
    this.label = label;
  }
}
